import React from 'react';
import IndeedPaper from './IndeedPaper';
import { IndeedPaperProps } from '../IndeedModels';

const IndeedCard = ({ children, style }: IndeedPaperProps) => {
    return <IndeedPaper style={style}>{children}</IndeedPaper>;
};

export default IndeedCard;
